export enum PaymentMethodId {
  ON_ACCOUNT = 'b52b8e0fc0ef40638f8b52618b4c2240',
  DEBIT = '911d6479fb6a43129a82dc0bc19c804c',
}
